module.exports = __webpack_public_path__ + "static/stamy-logo-54d7919cc50b9056221a6115b65901de.png";